import { useEffect, useState } from 'react';

// -----------------------------------------------------------------------------
const useIsIframe = (): boolean => {
  const [isIframe, setIsIframe] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsIframe(window.self !== window.top);
    }
  }, []);

  return isIframe;
};

export default useIsIframe;